import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wallet-employe-module',
  templateUrl: './wallet-employe-module.component.html',
  styleUrls: ['./wallet-employe-module.component.css']
})
export class WalletEmployeModuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
